import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Link from '../../components/link/internal-link';
import CommentHeader from '../../components/comment-header';
import CommentFooter from '../../components/comment-footer';
import Highlighter from '../../components/highlighter';
import withFontClassName from '../../hoc/with-font-class-name';
import { getCategory } from '../../selectors/categories-selectors';
import styles from './comment-search-list-item.scss';
import ContentExcerpt from '../../components/content-excerpt';
import withCardBorderWidth from '../../hoc/with-card-border-width';

const CommentSearchListItem = ({
  category,
  comment,
  type,
  query,
  onLikeClick,
  borderWidth,
  titleFontClassName,
  contentFontClassName,
}) => {
  const commentLink = `/${category.slug}/${comment.postSlug}#${comment._id}`;
  return (
    <Link to={commentLink} renderInSeo={false}>
      <article
        className={classNames(
          styles.container,
          'forum-card-background-color',
          'forum-text-color',
          'forum-card-border-color',
          contentFontClassName
        )}
        style={{ borderWidth }}
      >
        <div className={titleFontClassName}>
          <h2 className={styles.postTitle} data-hook="search-list-item__post-title">
            <object type="communities/link">
              <Link to={commentLink} style={{ color: 'inherit' }}>
                {comment.postTitle}
              </Link>
            </object>
          </h2>
        </div>
        <CommentHeader type={CommentHeader.SEARCH} comment={comment} showMoreButton/>
        <div className={styles.content}>
          <ContentExcerpt type={type} content={comment.content} query={query}/>
          {query ? <Highlighter text={comment.content} query={query}/> : comment.content}
        </div>
        <CommentFooter type={CommentFooter.SEARCH} comment={comment} onLikeClick={onLikeClick}/>
      </article>
    </Link>
  );
};

CommentSearchListItem.propTypes = {
  category: PropTypes.object.isRequired,
  comment: PropTypes.object.isRequired,
  borderWidth: PropTypes.number,
  type: PropTypes.string,
  onLikeClick: PropTypes.func.isRequired,
  titleFontClassName: PropTypes.string.isRequired,
  contentFontClassName: PropTypes.string.isRequired,
  query: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => ({
  category: getCategory(state, ownProps.comment.categoryId),
});

export default connect(mapStateToProps)(withCardBorderWidth(withFontClassName(CommentSearchListItem)));



// WEBPACK FOOTER //
// ./app/components/comment-search-list-item/comment-search-list-item.js